'use client';

import { ReactNode } from 'react';
import { usePathname } from 'next/navigation';

export interface IToolbarHeadingProps {
  title?: string | ReactNode;
  description?: string | ReactNode;
}

// Convert path like "/reset-password" → "Reset Password"
const getDefaultTitleFromPath = (pathname: string) => {
  const segments = pathname.split('/').filter(Boolean);
  if (!segments.length) return 'Home';
  const last = segments[segments.length - 1];
  return decodeURIComponent(last)
    .replace(/[-_]/g, ' ')
    .replace(/\b\w/g, l => l.toUpperCase());
};

const ToolbarHeading = ({ title = '', description }: IToolbarHeadingProps) => {
  const pathname = usePathname();
  const defaultTitle = getDefaultTitleFromPath(pathname);

  return (
    <div className="flex flex-col justify-center gap-2">
      <h1 className="text-xl font-medium leading-none text-gray-900">
        {title || defaultTitle}
      </h1>
      {description && (
        <div className="flex items-center gap-2 text-sm font-normal text-gray-700">
          {description}
        </div>
      )}
    </div>
  );
};

export { ToolbarHeading };
